<template>
  <Fragment>
    <template v-if="$route.name !== 'baseDataXT'">
      <router-view></router-view>
    </template>
    <section class="container" v-else>
      <Breadcrumb />
      <div class="card-wrap mt-20 mb-20">
        <section class="card-content">
          <div class="left">
            <div class="search-name mr-15">
              <span>线体名称：</span>
              <el-input v-model="productLineName"> </el-input>
            </div>
            <el-button
              type="primary"
              class="ml-20"
              @click="searchBaseDataXtInfo"
              >查询</el-button
            >
          </div>
        </section>
      </div>
      <el-table :data="list" style="width: 100%" border>
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            <span>{{ scope.$index + (pageNum - 1) * pageSize + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="线体名称" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.productLineName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="流水码" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.ioidCode }}</span>
          </template>
        </el-table-column>
        <el-table-column label="线体编码" width="250">
          <template slot-scope="scope">
            <span>{{ scope.row.productLineCode }}</span>
          </template>
        </el-table-column>
        <el-table-column label="添加时间" :fit="true">
          <template slot-scope="scope">
            <span>{{ scope.row.addDate }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20 pagination"
        background
        layout="total,prev, pager, next, jumper"
        :total="total"
        :page-size="10"
        :current-page="pageNum"
        @prev-click="handlePrePage"
        @next-click="handleNextPage"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </section>
  </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";

import Breadcrumb from "@/components/Breadcrumb";
export default {
  name: "role",
  components: {
    Breadcrumb,
    Fragment
  },
  data() {
    return {
      productLineName: "",
      list: [],
      pageNum: 1,
      pageSize: 10,
      total: 0
    };
  },
  methods: {
    getBaseDataXtList() {
      let _this = this;
      let param = {
        url: "/api/inquiryCode/getBaseDataXtList",
        params: {
          productLineName: _this.productLineName,
          pageNum: _this.pageNum,
          pageSize: _this.pageSize
        }
      };

      _this.$store.dispatch("getBaseDataXtList", param).then(() => {
        _this.list = _this.$store.state.product.productBaseDataXTList.list;
        _this.total = _this.$store.state.product.productBaseDataXTList.total;
      });
    },
    //查询
    searchBaseDataXtInfo() {
      let _this = this;
      _this.getBaseDataXtList();
    },
    //当前页
    handleCurrentChange(value) {
      let _this = this;
      _this.pageNum = value;
      _this.getBaseDataXtList();
    },
    //上一页
    handlePrePage() {
      let _this = this;
      _this.pageNum -= 1;
      _this.getBaseDataXtList();
    },
    //下一页
    handleNextPage() {
      let _this = this;
      _this.pageNum += 1;
      _this.getBaseDataXtList();
    }
  },
  created() {
    let _this = this;
    _this.getBaseDataXtList();
  }
};
</script>

<style lang="sass" scoped>
.card-wrap
  .card-content
    display: flex
    align-items: center
    justify-content: space-between
    .left
      display: flex
    .el-button
      font-size: 14px
    .search-name, .search-code
      font-size: 14px
      display: flex
      align-items: center
      span
        white-space: nowrap
.pagination
  text-align: center
</style>
